import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Theme } from "@mui/material/styles/createTheme";
import { Box } from "@mui/material";

const dots = keyframes`
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow:
            .25em 0 0 rgba(0, 0, 0, 0),
            .5em 0 0 rgba(0, 0, 0, 0);
  }

  40% {
    color: white;
    text-shadow:
            .25em 0 0 rgba(0, 0, 0, 0),
            .5em 0 0 rgba(0, 0, 0, 0);
  }

  60% {
    text-shadow:
            .25em 0 0 white,
            .5em 0 0 rgba(0, 0, 0, 0);
  }

  80%,
  100% {
    text-shadow:
            .25em 0 0 white,
            .5em 0 0 white;
  }
`;

export const PreLoader = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99998;
  background-color: ${props => (props.theme as Theme).palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-out;
  transform: scaleY(1);
  transform-origin: top;
`;

export const LoaderWrap = styled.div`
  width: 300px;
  text-align: center;
  color: #ececec;
`;

export const LoaderImg = styled.img`
  width: 150px;
  height: 150px;
  margin: 0 auto;
  margin-bottom: 10px;
  object-fit: contain;
`;

export const LoadingDots = styled.p`
  position: relative;
  margin: 0;

  &:after {
    content: " . ";
    animation: ${dots} 1s steps(5, end) infinite;
  }
`;

export const ProgressLoaderStyle = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & p {
    margin-top: 11px;
  }
`;
